// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"bZ-z","sponsoredTooltipWrapper":"cZ-z","sponsoredTooltip":"dZ-z","newCard":"eZ-z"};